import { type Registry as Services, service } from '@ember/service';
import type Transition from '@ember/routing/transition';
import { hash } from 'rsvp';
import ProtectedRoute from 'uplisting-frontend/pods/base/protected-route';
import AiMessagingControlsController from 'uplisting-frontend/pods/ai-messaging/controls/controller';

export default class AiMessagingControlsRoute extends ProtectedRoute {
  @service('repositories/ai-setting')
  settingRepository!: Services['repositories/ai-setting'];

  @service('repositories/property')
  propertyRepository!: Services['repositories/property'];

  model() {
    return hash({
      settings: this.settingRepository.findAll(),
      properties: this.propertyRepository.findAll(),
    });
  }

  setupController(
    controller: AiMessagingControlsController,
    model,
    transition: Transition,
  ): void {
    super.setupController(controller, model, transition);
    Object.assign(controller, model);
    controller.syncCurrentValues();
  }

  resetController(
    controller: AiMessagingControlsController,
    isExiting: boolean,
    transition: Transition,
  ): void {
    super.resetController(controller, isExiting, transition);

    if (isExiting) {
      controller.tab = null;
      controller.property = null;
      controller.isSaving = false;

      controller.syncCurrentValues();
    }
  }
}

export type AiMessagingControlsRouteModel =
  RouteModel<AiMessagingControlsRoute>;
